Vendd.Scripts.load(function () {

	function init(context) {
		var $context = $(context);
		var $wrapper = $('.x-warehouse-selector-popup-step-one_B', $context);

		if ($wrapper.length < 1) {
			return;
		}

		var wrapper = $wrapper.get(0),
			$root,
			$postCode,
			$postCodeButton,
			$area,
			$submitButton;

		var state = {
			postCode: undefined,
			area: undefined
		};

		/* State management variables for the dynamic fetching of the GeoArea option list,
		 * to enable re-fetching, given that it doesn't support immediate cancellation. */
		var shouldReloadAreas = false;
		var loadingAreas = false;

		wrapper.init = function () {
			$root = $('.warehouse-selector-popup-step-one', $wrapper);
			$postCode = $(':input[name="postcode"]', $root);
			$postCodeButton = $('.js-lookup', $root);
			$area = $(':input[name="area"]', $root);
			$submitButton = $('.js-submit', $root);

			state.postCode = $postCode.selectedVal() || '';
			state.area = $area.selectedVal() || '';

			wrapper.updateViewState();
		};

		wrapper.updateViewState = function () {
			$postCodeButton.toggleDisabled(state.postCode === '');
			$area.toggleDisabled($('option', $area).length <= 1);
			$submitButton.toggleDisabled(state.postCode === '' || state.area === '');
		};

		wrapper.loading = function (status) {
			if (status === undefined) {
				return $wrapper.hasClass('x-loading');
			} else {
				$wrapper.toggleClass('x-loading', status);
			}
		};

		wrapper.loadAreas = function () {
			if (state.postCode === '') {
				return;
			}
			if (loadingAreas) {
				shouldReloadAreas = true;
				return;
			}

			$area.find('option').slice(1).remove();
			$area.val('');
			wrapper.updateArea('');

			shouldReloadAreas = false;
			loadingAreas = true;

			Vendd.MessageBus.publish(wrapper, new Vendd.WarehouseSelector.Messages.GetGeoAreas(
				state.postCode
			));
		};

		wrapper.onAreasLoaded = function (model) {
			loadingAreas = false;

			if (shouldReloadAreas) {
				wrapper.loadAreas();
				return;
			}
			if (model) {
				wrapper.updateAreaSelector(model);
			}
		};

		wrapper.updateAreaSelector = function (model) {
			/* console.log('[WarehouseSelector] Areas JSON model: ' + JSON.stringify(model)); */
			var html = Vendd.Handlebars.parse("warehouseSelectorAreaSelector_A", model.GeoAreas);
			$('.x-warehouse-selector-area-selector', $wrapper).html(html);
			wrapper.init();
		};

		wrapper.updatePostCode = function (value) {
			if (state.postCode !== value) {
				/* console.log('[WarehouseSelector] PostCode: "' + state.postCode + '" -> "' + value + '"'); */
				state.postCode = value;
				wrapper.loadAreas();
				wrapper.updateViewState();
			}
		};

		wrapper.updateArea = function (value) {
			if (state.area !== value) {
				/* console.log('[WarehouseSelector] Area: "' + state.area + '" -> "' + value + '"'); */
				state.area = value;
				wrapper.updateViewState();
			}
		};

		$wrapper.on('click', '.js-lookup', function (e) {
			e.preventDefault();
			/* NOTE: Will only initiate a lookup operation if postcode has been modified since last lookup. */
			wrapper.updatePostCode($postCode.val());
			/* console.log("[WarehouseSelector] Looking up " + state.postCode); */
		});

		$wrapper.on('click', '.js-submit', function (e) {
			e.preventDefault();
			wrapper.loading(true);
			Vendd.MessageBus.publish(wrapper, new Vendd.WarehouseSelector.Messages.GetStoresByGeoArea(
				state.postCode,
				state.area
			));
		});

		$wrapper.on('change', ':input[name="postcode"]', function (e) {
			wrapper.updatePostCode($postCode.val());
		});

		$wrapper.on('keyup', ':input[name="postcode"]', function (e) {
			e.preventDefault();
		});

		$wrapper.on('keyup', ':input[name="postcode"]', $.debounce(500, function () {
			wrapper.updatePostCode($postCode.val());
		}));

		$wrapper.on('change', ':input[name="area"]', function (e) {
			wrapper.updateArea($area.val());
		});

		Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetGeoAreasSuccess, wrapper, function (envelope) {
			var model = envelope.message.data.data;
			wrapper.onAreasLoaded(model);
		});

		Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetGeoAreasFailed, wrapper, function () {
			/* TODO: Shall we provide additional error handling? */
		});

		Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetStoresSuccess, wrapper, function () {
			wrapper.loading(false);
		});

		Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetStoresFailed, wrapper, function () {
			wrapper.loading(false);
			/* TODO: Shall we provide additional error handling? */
		});

		wrapper.init();
	}

	Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-warehouse-selector-popup-step-one_B', function (envelope) {
		if (envelope.message.data.context === 'x-warehouse-selector-popup') {
			init(envelope.sender);
		}
	});
});
